module.exports = __webpack_public_path__ + "img/aftee.d0921559.png";